import React from "react";
import VideoDetail from "../../../components/faceswap/Video.jsx/VideoDetail";

export default function VideoDetails() {
  return <VideoDetail />;
}
